import React from 'react';
import {Alert, CircularProgress, Typography} from '@mui/material';

export const LoadingSpinner = () => <CircularProgress size="2rem" sx={{margin: '1rem 0'}} />;

export const A360CommissionsSectionNoRecordsFound = () => (
  <Typography className="a360-commissions__no-records">No Records Found.</Typography>
);

export const A360CommissionsSectionError = ({error}: {error?: string}) => {
  const errorMessage = error ?? 'An error occurred.';

  return <Typography sx={{padding: '1rem 0'}}>{errorMessage}</Typography>;
};

export const A360CommissionsAlert = ({message}: {message: string}) => (
  <Alert severity="info" variant="outlined" className="a360-commissions__alert">
    {message}
  </Alert>
);
